import { render, staticRenderFns } from "./SorryPage.vue?vue&type=template&id=5456ff23&scoped=true"
import script from "./SorryPage.vue?vue&type=script&lang=js"
export * from "./SorryPage.vue?vue&type=script&lang=js"
import style0 from "./SorryPage.vue?vue&type=style&index=0&id=5456ff23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456ff23",
  null
  
)

export default component.exports